var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.457C4.78501 19.457 0.542969 15.215 0.542969 10C0.542969 4.78501 4.78501 0.542969 10 0.542969C15.215 0.542969 19.457 4.78501 19.457 10C19.457 15.215 15.215 19.457 10 19.457ZM10 2.05609C5.6195 2.05609 2.05609 5.6195 2.05609 10C2.05609 14.3805 5.6195 17.9439 10 17.9439C14.3805 17.9439 17.9439 14.3797 17.9439 10C17.9439 5.62026 14.3805 2.05609 10 2.05609Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0017 15.0945C9.85407 15.0945 9.71251 15.0359 9.60813 14.9315C9.50376 14.8271 9.44512 14.6856 9.44512 14.5379V5.4592C9.44512 5.31159 9.50375 5.17003 9.60813 5.06565C9.71251 4.96127 9.85407 4.90264 10.0017 4.90264C10.1493 4.90264 10.2909 4.96127 10.3952 5.06565C10.4996 5.17003 10.5582 5.31159 10.5582 5.4592V14.5379C10.5582 14.6856 10.4996 14.8271 10.3952 14.9315C10.2909 15.0359 10.1493 15.0945 10.0017 15.0945Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5379 10.5582H5.4592C5.31159 10.5582 5.17003 10.4995 5.06565 10.3952C4.96127 10.2908 4.90264 10.1492 4.90264 10.0016C4.90264 9.85399 4.96127 9.71243 5.06565 9.60805C5.17003 9.50368 5.31159 9.44504 5.4592 9.44504H14.5379C14.6856 9.44504 14.8271 9.50368 14.9315 9.60805C15.0359 9.71243 15.0945 9.85399 15.0945 10.0016C15.0945 10.1492 15.0359 10.2908 14.9315 10.3952C14.8271 10.4995 14.6856 10.5582 14.5379 10.5582Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddnew);
export default __webpack_public_path__ + "static/media/addnew.12e586fc4504b9a50fdf28978bfc3c27.svg";
export { ForwardRef as ReactComponent };